import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Icon } from "../../icon";
import { KeyBoardKeys } from "../../types";
import { OptionsWrapper } from "./optionswrapper";
import { Wrapper, StyledDropdownValue, Title } from "./dropdown.styles";
function getListElements(wrapperRef) {
    const htmlListElement = wrapperRef.current.querySelectorAll("li");
    const firstLiElement = htmlListElement[0];
    const lastLiElement = htmlListElement[htmlListElement.length - 1];
    return { htmlListElement, firstLiElement, lastLiElement };
}
export function Dropdown({ items, onChange, indicatorLabel, }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptionValue, setSelectedOptionText] = useState(items[0].value);
    const [focused, setFocused] = useState(false);
    const dropDownValueRef = useRef(null);
    const wrapperRef = useRef(null);
    function watchClickOutside(event) {
        if (!isOpen) {
            return;
        }
        const didClickedOutside = !wrapperRef.current.contains(event.target) &&
            event.target.tagName !== "svg";
        if (didClickedOutside) {
            setIsOpen(false);
        }
    }
    useEffect(() => {
        document.addEventListener("click", watchClickOutside);
        return () => {
            document.removeEventListener("click", watchClickOutside);
        };
    }, [wrapperRef, isOpen]);
    function onKeyDownHandler(ev) {
        if (ev.code === KeyBoardKeys.ArrowDown) {
            if (!isOpen) {
                setIsOpen(true);
                return;
            }
            const { firstLiElement, htmlListElement } = getListElements(wrapperRef);
            if (ev.target.contains(dropDownValueRef.current)) {
                firstLiElement.focus();
            }
            else {
                for (let liItemIndex = 0; liItemIndex < htmlListElement.length; liItemIndex += 1) {
                    if (document.activeElement.contains(htmlListElement[liItemIndex])) {
                        if (liItemIndex < htmlListElement.length - 1) {
                            const nextElement = htmlListElement[liItemIndex + 1];
                            nextElement.focus();
                        }
                        else {
                            firstLiElement.focus();
                        }
                        break;
                    }
                }
            }
            return;
        }
        if (ev.code === KeyBoardKeys.ArrowUp) {
            if (!isOpen) {
                setIsOpen(true);
                return;
            }
            const { lastLiElement, htmlListElement } = getListElements(wrapperRef);
            if (ev.target.contains(dropDownValueRef.current)) {
                lastLiElement.focus();
            }
            else {
                for (let liItemIndex = 0; liItemIndex < htmlListElement.length; liItemIndex += 1) {
                    if (document.activeElement.contains(htmlListElement[liItemIndex])) {
                        if (liItemIndex > 0) {
                            const prevElement = htmlListElement[liItemIndex - 1];
                            prevElement.focus();
                        }
                        else {
                            lastLiElement.focus();
                        }
                        break;
                    }
                }
            }
            return;
        }
        if (ev.code === KeyBoardKeys.Home) {
            if (!isOpen) {
                return;
            }
            const { firstLiElement } = getListElements(wrapperRef);
            firstLiElement.focus();
            return;
        }
        if (ev.code === KeyBoardKeys.End) {
            if (!isOpen) {
                return;
            }
            const { lastLiElement } = getListElements(wrapperRef);
            lastLiElement.focus();
            return;
        }
        if (ev.code === KeyBoardKeys.Enter || ev.code === KeyBoardKeys.Space) {
            const { htmlListElement } = getListElements(wrapperRef);
            if (!ev.target.contains(dropDownValueRef.current)) {
                for (let htmlListElementIndex = 0; htmlListElementIndex < htmlListElement.length; htmlListElementIndex += 1) {
                    if (document.activeElement.contains(htmlListElement[htmlListElementIndex])) {
                        htmlListElement[htmlListElementIndex].click();
                        break;
                    }
                }
            }
            return;
        }
        if (ev.code === KeyBoardKeys.Escape) {
            setIsOpen(false);
        }
    }
    useEffect(() => {
        document.addEventListener("keydown", onKeyDownHandler);
        return () => {
            document.removeEventListener("keydown", onKeyDownHandler);
        };
    }, [isOpen]);
    return (_jsxs(Wrapper, Object.assign({ ref: wrapperRef }, { children: [_jsxs(StyledDropdownValue, Object.assign({ "data-focus-visible": focused, ref: dropDownValueRef, onKeyUp: (e) => {
                    if (e.key === KeyBoardKeys.Tab) {
                        setFocused(true);
                    }
                    if (e.key === KeyBoardKeys.Enter ||
                        e.key === KeyBoardKeys.Space ||
                        e.key === " ") {
                        setIsOpen(!isOpen);
                    }
                    if (e.key === KeyBoardKeys.Escape) {
                        setIsOpen(false);
                    }
                }, onBlur: () => {
                    setFocused(false);
                }, onMouseDown: () => {
                    setFocused(false);
                }, focused: focused, tabIndex: 0, onClick: () => {
                    setIsOpen(!isOpen);
                } }, { children: [_jsxs(Title, { children: [selectedOptionValue, " / ", indicatorLabel] }), _jsx(Icon, { withHitSpace: true, symbol: isOpen ? "ChevronUp" : "ChevronDown" })] })), isOpen && (_jsx(OptionsWrapper, { initialSelectedOption: selectedOptionValue, className: "flyout", outlined: true, onChange: (o) => {
                    if (typeof onChange === "function") {
                        setSelectedOptionText(o.value);
                        onChange(Number(o.value));
                    }
                    setIsOpen(false);
                }, items: items }))] })));
}
